import React from 'react';
import { hot } from 'react-hot-loader';

export default hot(module)(function Card(props) {
	return (
		<div className="card">
			<div className="card-body">{props.children}</div>
		</div>
	);
});
